'use client';
import '../styles/globals.css';
import type { ErrorBoundaryProps } from '@jci/components/ErrorBoundary';
import { ClientProviders } from './ClientProviders';
import GlobalErrorContent from './GlobalErrorContent';

export default function GlobalError(props: ErrorBoundaryProps) {
  return (
    <html data-theme="winter">
      <body suppressHydrationWarning className="overflow-y-scroll">
        <ClientProviders>
          <GlobalErrorContent {...props} />
        </ClientProviders>
      </body>
    </html>
  );
}
